import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { NG_LOCATION_TOKEN } from '@cpm-pr1618002/ng-utility-lib';

import { Observable } from 'rxjs';
import { redirectToTrustedUrl } from 'src/app/utils/redirect.utils';
import { environment } from 'src/environments/environment';
import {
  AccountMessage,
  AccountNotification,
  Contacts,
  UserLogout,
} from './state/user-management.state';

export const getTrustedCuiOrigins = (cuiAppUrl: string): string[] => {
  try {
    return [new URL(cuiAppUrl).origin];
  } catch {
    return [];
  }
};

const trustedCuiOrigins: string[] = getTrustedCuiOrigins(environment.cuiAppUrl);

@Injectable({
  providedIn: 'root',
})
export class UserManagementService {
  private apiServerHost: string = environment.apiServerHost;
  private cuiAppUrl: string = environment.cuiAppUrl;
  constructor(
    private httpClient: HttpClient,
    @Inject(NG_LOCATION_TOKEN) private location: Location,
  ) {}

  logOutUser(userId: number): Observable<UserLogout> {
    return this.httpClient.post<UserLogout>(
      `${this.apiServerHost}/cm-services/api/v1/login-service/users/${userId}/sign-out`,
      {
        userId,
      },
      { withCredentials: true },
    );
  }

  redirectToLogin(): void {
    redirectToTrustedUrl(this.cuiAppUrl, trustedCuiOrigins);
  }

  getNotifications(
    userId: number,
    offsetLimit: number,
    maxResults: number,
  ): Observable<AccountNotification> {
    return this.httpClient.get<AccountNotification>(
      `${this.apiServerHost}/cm-services/api/v1/account-service/users/${userId}/notifications?offsetLimit=${offsetLimit}&maxResults=${maxResults}`,
    );
  }

  getMessages(userId: number): Observable<AccountMessage[]> {
    return this.httpClient.get<AccountMessage[]>(
      `${this.apiServerHost}/cm-services/api/v1/account-service/users/${userId}/messages`,
    );
  }

  getContacts(userId: number): Observable<Contacts[]> {
    return this.httpClient.get<Contacts[]>(
      `${this.apiServerHost}/cm-services/api/v1/account-service/users/${userId}/contacts/get-contacts`,
    );
  }
}
